import store from "@/store";
import { computed, defineComponent, onBeforeUnmount, onMounted } from "vue";

export default defineComponent({
  name: 'SortByModal',
  components: {
  },
  props: {
    position: {
      type: Object,
      required: true,
    },
    positionClone: {
      type: Object,
      required: true,
    },

  },
  emits: ['close-sort-by', 'apply-sort'],
  setup(props, { emit }) {

    const lowToHighFilter = computed(() =>
      store.getters.configurationParams.earlyAccessEnabled ? "10" : "3"
    );
    const highToLowFilter = computed(() =>
      store.getters.configurationParams.earlyAccessEnabled ? "11" : "4"
    );

    const sortByButton = document.getElementById('sort-by-button');

    const selectSortOption = (orderBy: any) => {
      emit("apply-sort", orderBy);
      if(sortByButton){
        setTimeout(() => {
          sortByButton.classList.remove("isActive");
        },50)
      } 
      emit("close-sort-by"); // Chiude il modal
      store.dispatch("setSortByOpened", false);
    }

    const closeSortByModal = () => {
      store.dispatch("setSortByOpened", false);
      if(sortByButton){
        setTimeout(() => {
          sortByButton.classList.remove("isActive");
        },50)
      } 
      emit('close-sort-by');

    }
    onMounted(() => {
      setTimeout(() => {
        const button = document.getElementById("sort-by-button-clone");
        if (button) {
          button.classList.add("rotate-icon");
        }
      }, 50); 
    });

    return {
      selectSortOption,
      lowToHighFilter,
      highToLowFilter,
      closeSortByModal
    };
  },
});